import { type FC } from 'react'

import { type OfferV11, type PimProductV11 } from '@redteclab/api/clients/bully'
import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { Skeleton } from 'base-ui'

import { ProductRecommendationWidgetBuyTogetherAddToCartButton } from './ProductRecommendationAreaBuyTogetherAddToCartButton'

type ProductRecommendationWidgetBuyTogetherAddToCartProps = {
  currentOffer: OfferV11
  currentVariant: PimProductV11
  onGtmDataLayerPush: () => void
  recommendedProduct?: GkAirRecommendedProductDataWeb
}

export const ProductRecommendationWidgetBuyTogetherAddToCart: FC<
  ProductRecommendationWidgetBuyTogetherAddToCartProps
> = ({ recommendedProduct, ...props }) => {
  if (!recommendedProduct) {
    return <Skeleton className="mt-7 h-12" variant="rectangular" />
  }

  return (
    <ProductRecommendationWidgetBuyTogetherAddToCartButton
      {...props}
      recommendedProduct={recommendedProduct}
    />
  )
}
